import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService {
  public isMobile: Observable<boolean>;
  constructor(private breakpointObserver: BreakpointObserver) {
    this.isMobile = this.getIsMobile();
  }

  public getIsMobile(): Observable<boolean> {
    const tailwindBreakpoints = {
      Small: '(max-width: 640px)',
      Medium: '(max-width: 768px)',
      Large: '(max-width: 1024px)',
      XLarge: '(max-width: 1280px)',
    };

    const breakpoints = { ...Breakpoints, ...tailwindBreakpoints };

    return this.breakpointObserver
      .observe([breakpoints.Medium])
      .pipe(map((result) => result.matches));
  }
}
